import React from 'react'
import { Tab, withStyles } from '@material-ui/core'
import { secondaryB, secondaryC } from 'asterX-UIkit/constants/colors'

const AsterTab = withStyles(theme => ({
	root: {
		textTransform: 'none',
		paddingLeft: 16,
		paddingRight: 16,
		paddingTop: 12,
		paddingBottom: 12,
		height: 41,
		borderRadius: 9,
		fontWeight: 600,
		marginRight: 16,
		backgroundColor: secondaryB,
		color: secondaryC,
		opacity: 0.5,
		'&:hover': {
			color: secondaryC,
			opacity: 1
		},
		'&$selected': {
			backgroundColor: secondaryB,
			color: secondaryC,
			opacity: 1,
			fontWeight: 600
		},
		'&:focus': {
			color: secondaryC
		}
	},
	selected: {}
}))(props => <Tab disableRipple {...props} />)
export default AsterTab
